import React, { useEffect, useState } from "react";

const AddTableModal = ({
  open,
  onClose,
  onSave,
  mode = "add", // "add" | "edit"
  initialData = null, // table object for edit
}) => {
  const [tableNumber, setTableNumber] = useState("");
  const [capacity, setCapacity] = useState("");
  const [saving, setSaving] = useState(false);

  // Prefill when editing
  useEffect(() => {
    if (mode === "edit" && initialData) {
      setTableNumber(initialData.tableNumber || "");
      setCapacity(initialData.capacity || "");
    } else {
      setTableNumber("");
      setCapacity("");
    }
  }, [mode, initialData, open]);

  const handleSave = async () => {
    if (!tableNumber?.trim()) {
      alert("Table number is required");
      return;
    }

    if (!capacity || capacity < 1 || capacity > 15) {
      alert("Capacity must be between 1 and 15");
      return;
    }

    setSaving(true);
    try {
      const success = await onSave({
        tableNumber,
        capacity,
        _id: initialData?._id,
      });

      if (success) {
        onClose();
      }
    } finally {
      setSaving(false);
    }
  };

  if (!open) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
      <div className="bg-white rounded-xl shadow-xl w-[90%] max-w-[400px] mx-4">
        {/* Header */}
        <div className="flex justify-between items-center px-6 py-4 bg-gradient-to-r from-blue-600 to-blue-700 rounded-t-xl shadow-md">
          <h2 className="text-xl font-bold text-white flex items-center gap-2">
            <svg className="w-6 h-6" fill="currentColor" viewBox="0 0 20 20">
              <path
                fillRule="evenodd"
                d="M10 18a8 8 0 100-16 8 8 0 000 16zm1-11a1 1 0 10-2 0v2H7a1 1 0 100 2h2v2a1 1 0 102 0v-2h2a1 1 0 100-2h-2V7z"
                clipRule="evenodd"
              />
            </svg>
            {mode === "edit" ? "Edit Table" : "Add Table"}
          </h2>
          <button
            onClick={onClose}
            className="text-white hover:text-blue-100 transition-colors p-1 hover:bg-white/20 rounded-lg"
          >
            <svg
              className="w-6 h-6"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M6 18L18 6M6 6l12 12"
              />
            </svg>
          </button>
        </div>

        <div className="h-px bg-gray-200"></div>

        {/* Form */}
        <div className="p-6 space-y-4">
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">
              Table Number
            </label>
            <input
              type="text"
              value={tableNumber}
              onChange={(e) => setTableNumber(e.target.value)}
              disabled={mode === "edit"}
              className={`w-full px-3 py-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 ${
                mode === "edit"
                  ? "bg-gray-100 text-gray-600 cursor-not-allowed"
                  : "border-gray-300"
              }`}
              placeholder="Enter table number"
            />
          </div>

          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">
              Capacity
            </label>
            <input
              type="number"
              value={capacity}
              min={1}
              max={15}
              onChange={(e) => {
                const value = e.target.value;

                if (value === "") {
                  setCapacity("");
                  return;
                }

                const num = Number(value);

                if (num >= 1 && num <= 15) {
                  setCapacity(num);
                }
              }}
              className={`w-full px-3 py-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 ${
                capacity !== "" && (capacity < 1 || capacity > 15)
                  ? "border-red-500"
                  : "border-gray-300"
              }`}
              placeholder="Enter capacity (1-15)"
            />
            <p className="text-xs text-gray-500 mt-1">
              Capacity must be between 1 and 15
            </p>
          </div>

          <button
            onClick={handleSave}
            disabled={saving}
            className="w-full px-4 py-3 bg-gradient-to-r from-blue-600 to-blue-700 hover:from-blue-700 hover:to-blue-800 disabled:from-gray-400 disabled:to-gray-500 disabled:cursor-not-allowed text-white font-medium rounded-lg shadow-md hover:shadow-lg transition-all"
          >
            {saving ? "Saving..." : mode === "edit" ? "Update" : "Save"}
          </button>
        </div>
      </div>
    </div>
  );
};

export default AddTableModal;
